<app-nav-bar-session-ending></app-nav-bar-session-ending>
<main>
  <router-outlet></router-outlet>
  <app-modal-container></app-modal-container>
  <app-internet-check></app-internet-check>
</main>
<app-footer></app-footer>
